import React, { useEffect, useMemo, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider
} from "react-bootstrap-table2-paginator";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../_redux/organizationFileAction";
import * as uiHelpers from "../OrganizationFileUIHelpers";

import {
  getHandlerTableChange,
  NoRecordsFoundMessage,
  PleaseWaitMessage
} from "../../../../../_metronic/_helpers";
import * as columnFormatters from "./column-formatters";
import { Pagination } from "../../../../../_metronic/_partials/controls";
import { BlockOrg, RoleChecker } from "../../../../RoleChecker";
import FileSaver from "file-saver";
import ConfirmationDeleteModal from "../../../Project/pages/modal-for-project/ConfirmationDeleteModal";

const OrganizationFileTable = ({
  setDeleteModal,
  setEditModal,
  setRow,
  totalCount,
  setQueryParams,
  queryParams = {},
  listLoading,
  entities = []
}) => {
  // Table columns
  const columns = [
    // {
    //   dataField: "file",
    //   text: "Dokumen",
    //   formatter: cell => {
    //     const link = cell.storage + "/" + cell.path;
    //     return (
    //       <a
    //         class="link-primary text-primary"
    //         onClick={() => FileSaver.saveAs(link, cell.filename)}
    //         style={{ textDecoration: "underline" }}
    //       >
    //         Download
    //       </a>
    //     );
    //   }
    // },
    {
      dataField: "caption",
      text: "Nama Dokumen"
    },
    // {
    //   dataField: "status",
    //   text: "Status Approval",
    //   formatter: cell => {
    //     return <span>{cell ? cell : "-"}</span>;
    //   }
    // },
    {
      dataField: "action",
      text: "Actions",
      formatter: columnFormatters.ActionsColumnFormatter,
      formatExtraData: {
        setDeleteModal,
        setEditModal,
        setRow,
        blockOrg: BlockOrg()
      },
      classes: "text-right pr-0",
      headerClasses: "text-right pr-3",
      style: {
        minWidth: "100px"
      }
    }
  ];

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: totalCount,
    sizePerPageList: uiHelpers.sizePerPageList,
    sizePerPage: queryParams.pageSize,
    page: queryParams.pageNumber
  };

  return (
    <>
      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => {
          return (
            <Pagination
              isLoading={listLoading}
              paginationProps={paginationProps}
            >
              <BootstrapTable
                wrapperClasses="table-responsive"
                classes="table table-head-custom table-vertical-center overflow-hidden"
                bootstrap4
                bordered={false}
                remote
                keyField="uuid"
                data={entities === null ? [] : entities}
                columns={columns}
                // defaultSorted={uiHelpers.defaultSorted}
                onTableChange={getHandlerTableChange(setQueryParams)}
                {...paginationTableProps}
              >
                <PleaseWaitMessage entities={entities} />
                <NoRecordsFoundMessage entities={entities} />
              </BootstrapTable>
            </Pagination>
          );
        }}
      </PaginationProvider>
    </>
  );
};

export default OrganizationFileTable;
